import { v4 as UUIDv4 } from "uuid"

/**
 * Módulo que gerencia o estado das mensagens exibidas na aplicacao
 * @state Estados que devem ser controlados
 * @mutations Funções que tem permissão para alterar o state
 * @actions Executar operações asincronas e chamar mutations 
 * @getters Retorna o estado além da possibilidade de retornar a 
 * mesma lógica do computed (Gera valores com base em valores originais)
 */

const state = {
    /**
     * Estado que fica registrado as mensagens para o usuário padrão do objeto: 
     * @messageId = Identificador uuid da mensagem que foi enviada
     * @messageTitle = Titulo da mensagem a ser exibida
     * @messageText = Mensagem que deve ser exibida
     * @messageIcon = Icone da mensagem fontawesome https://fontawesome.com/icons?d=gallery
     * @messageType = Tipo da mensagem: 'warning', 'info' e 'error' caso nenhum seja escolhido sera o tipo 'default'
     */
    messages: []
}

const mutations = {
    /**
     * Seta o estado com os dados que forem passados como parametro da funcao
     */
    mutationShowMessage: (state : any, message : any): any => {
        message.messageId = UUIDv4();
        state.messages.push(message);
        setTimeout(() => {
            const messageIndex = state.messages.map((individualMessage : any) => {
                return individualMessage.messageId;
            }).indexOf(message.messageId);

            if (messageIndex > -1) {
                state.messages.splice(messageIndex, 1)
            }
        }, 5000);
    },
    /**
     * Mutation que remove uma mensagem da tela atraves do Id da mensagem
     *  que é passado como parametro
     */
    mutationRemoveMessage: (state : any, messageId : any): any => {
        const messageIndex = state.messages.map((individualMessage : any) => {
            return individualMessage.messageId;
        }).indexOf(messageId);

        if (messageIndex > -1) {
            state.messages.splice(messageIndex, 1);
        }
    }
}

const actions = {}

const getters = {
    /**
     * Retorna se o Navigation Drawer deve estar aberto ou fechado
     */
    getMessages: (state : any): any => state.messages
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}